import { render, staticRenderFns } from "./corder-refound-detail.vue?vue&type=template&id=ec4ca10e&scoped=true&"
import script from "./corder-refound-detail.vue?vue&type=script&lang=js&"
export * from "./corder-refound-detail.vue?vue&type=script&lang=js&"
import style0 from "./corder-refound-detail.vue?vue&type=style&index=0&id=ec4ca10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4ca10e",
  null
  
)

export default component.exports